// 需要 jquery   slick

// 需要 jquery slick

if (!customElements.get("scroll-store-message")) {
  customElements.define(
    "scroll-store-message",
    class ScrollStoreMessage extends HTMLElement {
      constructor() {
        super();

        this.marqueeDom = $(this).find(".marquee");
        this.initMarquee();
      }

      initMarquee() {
        const that = this;

        setTimeout(function () {
          const $marquee = $(that).find(".marquee");
          const $list = $marquee.find(".scroll_store__messages_list");
          const $items = $list.children(".scroll_store__message-content");

          if (!$marquee.length || !$list.length || !$items.length) {
            return;
          }

          /*
           * 关键处理：
           * 在 marquee 初始化之前，把消息补充到足够长。
           *
           * 这样 jquery.marquee 再 duplicated 时，
           * 每一整组内容本身就足够覆盖屏幕，
           * 不会滚完最后一条以后出现大段空白。
           */

          const containerWidth = $marquee.outerWidth();

          let originalWidth = 0;

          $items.each(function () {
            originalWidth += this.getBoundingClientRect().width;
          });

          // 保存原始消息
          const $originalItems = $items.clone(false);

          let totalWidth = originalWidth;
          let repeatCount = 0;

          /*
           * 至少让一整组消息达到屏幕宽度的 2 倍。
           *
           * 例如：
           * 屏幕 1440px
           * 消息总宽度 900px
           *
           * 会自动变成：
           * 900 → 1800 → 2700
           *
           * 然后再交给 jquery.marquee duplicated。
           */
          while (
            totalWidth < containerWidth * 2 &&
            repeatCount < 10
          ) {
            const $clone = $originalItems.clone(false);

            // 避免 Shopify Theme Editor 把复制内容识别为真实 block
            $clone.removeAttr("data-shopify-editor-block");

            $list.append($clone);

            totalWidth += originalWidth;
            repeatCount++;
          }

          /*
           * 明确告诉 marquee 这一组内容真正有多宽。
           * 不再让 width: 100% 干扰 jquery.marquee 的宽度计算。
           */
          $list.css({
            width: Math.ceil(totalWidth) + "px",
            flexShrink: 0
          });
          $marquee.marquee({
            startVisible: true,
            duplicated: true,
            speed: 40,
            pauseOnHover: true,
            loop: -1,
            pauseSpeed: 0
          });
        }, 0);
      }
    }
  );
}